import { all, put, takeLatest } from 'redux-saga/effects';

import {
  notebookNoteFailure,
  notebookNoteRequest,
  notebookNoteSuccess,
  shiftNoteRequest,
  shiftNotesSuccess,
  shiftNotesFailure,
  notebookNotesSuccess,
  notebookNotesFailure,
  notebookNotesRequest,
} from './actions';
import { notebookNoteTagsRequest } from 'ducks/notebookNoteTags/actions';
import axios from 'axios';
import { NOTEBOOK, SHIFTS } from 'app/api-routes';
import { formatDateTimeUTC } from 'util/formatting';

function* notebookNoteSaga({ payload: notebookNoteID }) {
  try {
    const { payload } = yield axios.get(`${NOTEBOOK}/${notebookNoteID}`);

    const { siteID } = payload;
    yield put(notebookNoteTagsRequest(siteID));

    yield put(notebookNoteSuccess(payload));
  } catch (err) {
    yield put(notebookNoteFailure(err));
  }
}

function* notebookNotesSaga({ payload: { startDate, endDate, userID, supervisorID, siteID, tagIDs } }) {
  try {
    const { payload } = yield axios.get(NOTEBOOK, {
      params: {
        fromDate: startDate ? formatDateTimeUTC(startDate) : null,
        toDate: endDate ? formatDateTimeUTC(endDate) : null,
        userID: userID || null,
        supervisorID: supervisorID || null,
        siteID: siteID || null,
        tagIDs: tagIDs?.length ? tagIDs : null,
      },
    });

    yield put(notebookNotesSuccess(payload));
  } catch (err) {
    yield put(notebookNotesFailure(err));
  }
}

function* shiftNotesSaga({ payload: shiftID }) {
  try {
    const response = yield axios.get(`${SHIFTS}/${shiftID}/notes`, {
      params: {
        sort: 'A',
      },
    });

    if (response.payload.length) {
      yield put(notebookNoteTagsRequest(response.payload[0].siteID));

      yield put(shiftNotesSuccess(response.payload[0]));
    }
  } catch (err) {
    yield put(shiftNotesFailure(err));
  }
}

export default function* () {
  yield all([
    yield takeLatest(notebookNotesRequest, notebookNotesSaga),
    yield takeLatest(notebookNoteRequest, notebookNoteSaga),
    yield takeLatest(shiftNoteRequest, shiftNotesSaga),
  ]);
}
